<template>
  <svg viewBox="-0.5 -0.5 21 21" fill="currentColor" stroke="currentColor" aria-hidden="true">
    <rect x="3" y="3" width="14" height="14" rx="7" stroke-width="3" fill="none" />
    <path stroke-width="3" d="M3,10 H 17" />
  </svg>
</template>
